import {memo} from 'react';

import {useSelector} from 'react-redux';

import {isJustEat} from '~/shared/config';
import {selectIsActiveBannersShown} from '~/shared/store/selectors';

const Footer = isJustEat
  ? require('./just-eat').default
  : require('./10bis').default;

const PageFooter = () => {
  const isBannersShown = useSelector(selectIsActiveBannersShown);
  return (
    <Footer isBannersShown={isBannersShown} />
  );
};

export default memo(PageFooter);
